export const eventBusMixin = {
    data() {
        return {
            _busListeners: [],
        }
    },
    beforeDestroy() {
        if (this.$bus && Array.isArray(this._busListeners)) {
            this._busListeners.forEach(({ event, handler }) => {
                this.$bus.off(event, handler)
            })
        }
        this._busListeners = []
    },
    methods: {
        emitBus(event, payload) {
            if (!this.$bus) return
            this.$bus.$emit(event, payload)
        },

        listenBus(event, handler) {
            if (!this.$bus || typeof handler !== 'function') return
            this.$bus.$on(event, handler)
            if (!this._busListeners) {
                this._busListeners = []
            }
            this._busListeners.push({ event, handler })
        },

        unlistenBus(event, handler) {
            if (!this.$bus) return
            this.$bus.$off(event, handler)
            if (Array.isArray(this._busListeners)) {
                this._busListeners = this._busListeners.filter(
                    (l) => !(l.event === event && l.handler === handler),
                )
            }
        },
    },
}

export default eventBusMixin
